import script from "./BaseSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSwitch.vue?vue&type=style&index=0&id=aebef08c&lang=scss"

const __exports__ = script;

export default __exports__